import CryptoJS from 'crypto-js';
import cookieService from './cookiesStorageService';

class TokenManagementService {
  setToken(cookieKey: string, token: string, secretKey: string, options: any) {
    let __token = '';
    __token = CryptoJS.AES.encrypt(token, secretKey || '').toString();
    cookieService.setValue(cookieKey, __token, options);
  }

  getToken(cookieKey: any, secretKey: string) {  
    if (cookieService.isItemAvailable(cookieKey)) {
      let encrypted_token = cookieService.getValue(cookieKey) || '';
      let byteData: CryptoJS.lib.WordArray | undefined;
      byteData = CryptoJS.AES.decrypt(encrypted_token, secretKey || '');
      if (byteData) {
        let data = CryptoJS.enc.Utf8.stringify(byteData);
        return data;
      }
    }
    return null;
  }
}

const tokenManagementService = new TokenManagementService();

Object.freeze(tokenManagementService);

export default tokenManagementService;
